import { render, staticRenderFns } from "./homePage5.vue?vue&type=template&id=31afeaa0&scoped=true"
import script from "./homePage5.vue?vue&type=script&lang=js"
export * from "./homePage5.vue?vue&type=script&lang=js"
import style0 from "./homePage5.vue?vue&type=style&index=0&id=31afeaa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31afeaa0",
  null
  
)

export default component.exports